import { createApp } from 'vue'
import { ref } from 'vue'
import store from '../store'
import pandirective from '../directives/pandirective'
import lang from '../lang'
import { SET_CURRENT_LANG, SET_USER_INFO } from '../constants/mutation-types'
import App from '../App.vue'
import { appType } from "../constants/constants"
import { config } from "../utils/globalconfig"

const app = createApp(App)

function changeLanguage (langType) {
  store.commit(SET_CURRENT_LANG, langType)
  app.config.globalProperties.$language.value = langType
  app.config.globalProperties.$t = (key) => {
    const langType = app.config.globalProperties.$language.value
    return lang[langType] ? lang[langType][key] : lang['ENU'][key]
  }
}

export default {
  startChatApp: (options) => {
    app.use(store)
    app.directive('pan', pandirective)

    app.config.globalProperties.$language = ref('ENU')
    changeLanguage(options.lang || 'ENU')
    app.config.globalProperties.$appType = appType.FMS
    if(typeof options.eventCountUnreadMessage === 'function'){
      app.config.globalProperties.$callbackCountUnreadMessage = options.eventCountUnreadMessage;
    }
    config.uri = options.uri

    app.mount('#app')
    store.commit(SET_USER_INFO, {companyName: options.coName, userName: options.account,
      password: options.password, type: appType.FMS, typeID: options.custId, userType: 1})
  },
  switchLanguage: (langType) => {
    changeLanguage(langType)
  }
}
